var React = require('react');

function IposWeb (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","d":"M14.145 13H1.783C1.35 13 1 12.664 1 12.25V1.75c0-.414.35-.75.783-.75h16.434c.432 0 .783.336.783.75v4.644","key":0}),React.createElement("path",{"stroke":"#000","strokeLinecap":"round","d":"M8 17l.571-4h2.858L12 17","key":1}),React.createElement("path",{"fillRule":"nonzero","stroke":"#02A2DC","strokeLinejoin":"round","d":"M18.622 12.935l-1.297 2.245-3.22-8.075 8.075 3.22-.893.516-1.353.781 2.773 2.773-1.312 1.312-.354-.353-2.419-2.42z","key":2}),React.createElement("path",{"stroke":"#000","strokeLinecap":"round","d":"M6 17.5h7.903","key":3})]));
}

IposWeb.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18"};

module.exports = IposWeb;

IposWeb.default = IposWeb;
